export const getCanvasState = (ref: HTMLElement | null) => {
  if (!ref) {
    return {
      scale: 1,
      translate: [0, 0],
    }
  }

  const tree = ref.querySelector('#tree') as HTMLElement
  const scale = parseFloat(
    tree.style.transform.split('scale(')[1].split(')')[0]
  )

  if (!ref.style.transform.includes('matrix3d')) {
    return {
      scale,
      translate: [0, 0],
    }
  }

  const matrix = ref.style.transform
    ?.split('matrix3d(')[1]
    ?.split(')')[0]
    ?.split(', ')

  return {
    scale,
    translate: [parseFloat(matrix[12]), parseFloat(matrix[13])],
  }
}
